import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const HeartSvg = () => /*#__PURE__*/_jsxs("svg", {
  viewBox: "0 0 1124 1012",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("radialGradient", {
      cx: "50%",
      cy: "28.8550993%",
      fx: "50%",
      fy: "28.8550993%",
      r: "71.2237499%",
      id: "radialGradient-3",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "var(--zen-design-primary-high-color)",
        stopOpacity: "0",
        offset: "0%"
      }), /*#__PURE__*/_jsx("stop", {
        stopColor: "var(--zen-design-primary-high-color)",
        stopOpacity: "0.58",
        offset: "100%"
      })]
    }), /*#__PURE__*/_jsx("filter", {
      x: "-5.9%",
      y: "-5.9%",
      width: "111.7%",
      height: "111.7%",
      filterUnits: "objectBoundingBox",
      id: "filter-4",
      children: /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "6",
        in: "SourceGraphic"
      })
    }), /*#__PURE__*/_jsxs("radialGradient", {
      cx: "50%",
      cy: "28.8550993%",
      fx: "50%",
      fy: "28.8550993%",
      r: "71.2237499%",
      id: "radialGradient-5",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "var(--zen-design-secondary-high-color,#00cc99)",
        stopOpacity: "0",
        offset: "0%"
      }), /*#__PURE__*/_jsx("stop", {
        stopColor: "var(--zen-design-secondary-high-color,#00cc99)",
        stopOpacity: "0.58",
        offset: "61.470768%"
      }), /*#__PURE__*/_jsx("stop", {
        stopColor: "var(--zen-design-secondary-high-color,#00cc99)",
        stopOpacity: "0.38",
        offset: "100%"
      })]
    }), /*#__PURE__*/_jsx("filter", {
      x: "-2.6%",
      y: "-2.6%",
      width: "105.1%",
      height: "105.1%",
      filterUnits: "objectBoundingBox",
      id: "filter-6",
      children: /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "6",
        in: "SourceGraphic"
      })
    })]
  }), /*#__PURE__*/_jsx("g", {
    id: "Landingpage&\u7A7A\u9875\u9762",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/_jsxs("g", {
      id: "\u7F16\u7EC4",
      transform: "translate(18.000000, 18.000000)",
      children: [/*#__PURE__*/_jsx("circle", {
        id: "\u5C0F\u5706",
        fill: "url(#radialGradient-3)",
        opacity: "0.166887556",
        filter: "url(#filter-4)",
        cx: "153.5",
        cy: "153.5",
        r: "153.5"
      }), /*#__PURE__*/_jsx("circle", {
        id: "\u5927\u5706",
        fill: "url(#radialGradient-5)",
        opacity: "0.166887556",
        filter: "url(#filter-6)",
        cx: "736",
        cy: "624",
        r: "352"
      })]
    })
  })]
});
export default HeartSvg;